module.exports = __webpack_public_path__ + "img/04.838fb35f.png";